<template>
	<div class="container4">

		<div class="leftmap">
			<el-bmap vid="landlayout" :zoom="zoom" :center="center" :events="events" class="bmap-demo">
				<el-bmap-label v-for="item in pointsList" :position="[item.lng, item.lat]" :visible="item.visible"
				 :offset="[-23,-52]"
					:is-custom="true">
					<div class="labelbox" style="color:#fff;font-size:20px;">

						<div class="labelcontent">
							<img class="iconimg" :src="item.imgurl" />
							<div class="labeltext">
								{{ item.name || '空' }}
							</div>
						</div>
						<span class="labeldown" style="color:#000"></span>
					</div>
				</el-bmap-label>
				

			</el-bmap>
			<ul class="drawing-panel">
					<el-button type="primary" size="mini" class="draw-btn" @click="myDis.open()">开启测距</el-button>
					<!-- <el-button type="primary" size="mini" class="draw-btn" @click="myDis.close()">关闭测距</el-button> -->
				</ul>
		</div>
	
		<div class="rightlist">
			<div class="toplist">


				<div class="toptitle">风险类别</div>
				<div class="topcon">
					<div class="topitem" v-for="item in showdata" :key="item.cateid">
						<el-switch class="switch" v-model="item.checked"></el-switch>
						<div class="iconbox">
							<img class="iconimg" :src="item.iconurl" alt="">
							<div class="iconcatename">{{ item.name }}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="bottomlist">
				<div class="bottomlistinner">
					<div class="btitle">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">地点名称
						</el-checkbox>
					</div>
					<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
						<div class="bitem" v-for="point in pointsList" :key="point.id">
							<el-checkbox :label="point.id">{{ point.name }}</el-checkbox>
						</div>
					</el-checkbox-group>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

import VueBMap from "vue-bmap-gl";


import { getDetail, downloadFileByCate, zhoubianData } from "../../api/data";
let bmapManager = new VueBMap.BMapManager()
const wenwu = require('@/assets/icon/wenwu.png')
const gaoya = require('@/assets/icon/gaoya.png')
const wuranyun = require('@/assets/icon/wuran.png')
const bingz = require('@/assets/icon/bingz.png')
const jingguan = require('@/assets/icon/jingguan.png')
const shangye = require('@/assets/icon/shangye.png')
const yiliao = require('@/assets/icon/yiliao.png')
const jiaoyu = require('@/assets/icon/jiaoyu.png')

const icontype7 = '@/assets/icon/wenwu.png'
const icontype8 = '@/assets/icon/gaoya.png'
const icontype9 = '@/assets/icon/wuran.png'
const icontype10 = '@/assets/icon/bingz.png'
const icontype3 = '@/assets/icon/jingguan.png'
const icontype4 = '@/assets/icon/shangye.png'
const icontype5 = '@/assets/icon/yiliao.png'
const icontype6 = '@/assets/icon/jiaoyu.png'



export default {
	name: 'FrontendPcBigdataLandlayout',
	components: { VueBMap },
	props: {
		cate: 1,  //1 周边配套 2宗地风险点
	},
	data() {
		return {
			checkAll: false,
			checkedCities: [1, 2],

			pointsList: [
				
			],
			isIndeterminate: true,

			id: 0,
			map: {},
			detail: {},
			myDis: {},
			zoom: 13,
			imglist: [],
			center: [],
			events: {
				init: (o) => {
					var mapType1 = new BMapGL.MapTypeControl({ mapTypes: [BMAP_HYBRID_MAP, BMAP_NORMAL_MAP] });
					o.addControl(mapType1);

					this.map = o
					var scaleCtrl = new BMapGL.ScaleControl();  // 添加比例尺控件
					this.map.addControl(scaleCtrl);
					var zoomCtrl = new BMapGL.ZoomControl();  // 添加缩放控件
					this.map.addControl(zoomCtrl);


					var myDis = new BMapGLLib.DistanceTool(o);

					// 监听测距过程中的鼠标事件
					myDis.addEventListener('drawend', function (e) {
						
					});
					myDis.addEventListener("addpoint", function (e) {
						
					});
					myDis.addEventListener("removepolyline", function (e) {
						
					});


					this.myDis = myDis


				},
			},
			showdata: [],
			catepeitao: [
				{
					cateid: 3,
					name: '景观资源',
					checked: true,
					iconurl: jingguan
				},
				{
					cateid: 4,
					name: '商业资源',
					checked: true,
					iconurl: shangye

				}, {
					cateid: 5,
					name: '医疗资源',
					checked: true,
					iconurl: yiliao
				}
				, {
					cateid: 6,
					name: '教育资源',
					checked: true,
					iconurl: jiaoyu
				}
			],

			catedata: [
				{
					cateid: 7,
					name: '文物古迹',
					checked: true,
					iconurl: wenwu
				},
				{
					cateid: 8,
					name: '高压线',
					checked: true,
					iconurl: gaoya
				}, {
					cateid: 9,
					name: '污染源',
					checked: true,
					iconurl: wuranyun
				}
				, {
					cateid: 10,
					name: '殡葬区',
					checked: true,
					iconurl: bingz
				}
			]

		};
	},

	watch: {
		showdata: {
			handler(nv, ov) {
				if (!nv.some(item => item.checked)) {  //若全部隐藏时候则显示第一个
					nv[0].checked = true
				}
				this.getCateData()
			},
			deep: true
		}
	},
	mounted() {

		if (this.cate === 1) {
			this.showdata = this.catepeitao
		} else {
			this.showdata = this.catedata
		}

		if (this.$route.params.id) {
			this.id = this.$route.params.id
		}
		this.getMapDetail().then(res => {
			this.drawPoint(this.detail)
			this.createOverlay(this.detail)
			this.getImgList()

			//获取分类数据
			this.getCateData()
		})

	},

	methods: {
		// 打开测距功能
		openDistanceTool(e) {
			alert(1)

			const { distanceTool } = this
			distanceTool && distanceTool.open()
		},


		//获取分类数据
		getCateData() {
			let t = []
			if (this.cate === 2) {  //周边风险点
				this.catedata.map(item => {
					if (item.checked === true) {
						t.push(item.cateid)
						// return item.cateid
					}
				})
				t = t.toString()
			} else { //周边配套
				this.catepeitao.filter(item => {
					if (item.checked === true) {
						t.push(item.cateid)
					}
				})
				t = t.toString()
			}

			const { sw, ne } = this.map.getBounds()
			const ru_lng = ne.lng
			const ru_lat = ne.lat
			const ll_lng = sw.lng
			const ll_lat = sw.lat
			const params = {
				ll_lng,
				ll_lat,
				ru_lng,
				ru_lat,
				type: t,
			}

			zhoubianData(params).then(res => {

				this.pointsList = this.handleImg(res.data)

				this.checkedCities = this.pointsList.map(item => item.id)

			})

		},

		handleImg(data) {
			const res = data.map(item => {
				item.imgurl = require('@/assets/icon/icontype' + item.type + '.png')
				return item
			})
			return res
		},


		handleCheckAllChange(val) {
			// alert(val)
			if (val === false) {
				this.pointsList = this.pointsList.map(item => {
					item.visible = false
					return item
				})
			} else {
				this.pointsList = this.pointsList.map(item => {
					item.visible = true
					return item
				})
			}
			this.checkedCities = val ? this.pointsList.map(item => item.id) : [];
			this.isIndeterminate = false;
		},
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.pointsList.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.pointsList.length;

			const currentlist = this.pointsList.map(item => {
				if (this.checkedCities.indexOf(item.id) !== -1) {
					item.visible = true
				} else {
					item.visible = false
				}
				return item
			})
			this.pointsList = currentlist
		},
		getImgList() {
			downloadFileByCate({ pid: this.id, category_id: 9 }).then(res => {
			
				this.imglist = res.data
			})

		},

		getMapDetail() {
			var that = this
			return new Promise(function (resolve, reject) {
				getDetail({ id: that.id }).then(res => {
					that.detail = res.data
					that.center = [
						res.data.lng,
						res.data.lat
					]
					resolve(res.data)
				})

			})

		},
		//画点
		drawPoint(itemdata) {

			const type5 = require('@/assets/point.png')

			const myIcon = new BMapGL.Icon(type5, new BMapGL.Size(50, 110), {
				imageOffset: new BMapGL.Size(0, 0)   // 设置图片偏移   
			})

			// 创建标注对象并添加到地图  
			const marker = new BMapGL.Marker(new BMapGL.Point(parseFloat(itemdata.lng), parseFloat(itemdata.lat)), { icon: myIcon });
			marker.id = itemdata.id
			this.map.addOverlay(marker);
		},


		// 创建一个多变形
		createOverlay(data) {

			const allset = data.set
			const setObj = JSON.parse(allset)
			setObj.map(item => {
				// data 是一个多变形的数据
				// 画一个多变形的方法
				this.createPolygon(item, data.id)
			})


		},

		createPolygon(data, id) {
			const pointobj = data.lnglat.split(';')
			const pointArr = pointobj.map(point => {
				const lnglat = point.split(',')
				return new BMapGL.Point(lnglat[0], lnglat[1])
			})

			const polygonAttribute = {

				strokeWeight: 2,
				strokeOpacity: 0.5,
				strokeColor: '#28A7E1',
				fillColor: data.color,
				fillOpacity: 1
			}

			const overlay = new BMapGL.Polygon(pointArr, polygonAttribute)

			overlay.mode = 'polygon'
			overlay.color = data.color
			overlay.index = data.index

			if (this.index < data.index) { // 更新当前的index
				this.index = data.index
			}
			overlay.id = id

			this.map.addOverlay(overlay)

		},


	},
};
</script>

<style lang="scss" scoped>
.drawing-panel {
	position: absolute;
	right: 100px;
	top:10px;
	height:40px;
	width:200px;
	background:'#fff';
	padding:0px;
	z-index:12;
	display: flex;
	justify-content: center;
	align-items: center;
}

.rightlist {
	margin-top: 10px;
	width: 244px;
	background: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;

	.toplist {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #F0F3F8;
		padding-bottom: 10px;

		.toptitle {
			margin: 10px 0;
			width: 72px;
			height: 25px;
			font-size: 18px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #000000;
			line-height: 25px;
		}

		.topcon {
			width: 224px;
			background: #F0F3F8;
			border-radius: 4px;
			display: flex;
			flex-direction: column;

			.topitem {
				display: flex;
				flex-direction: row;
				justify-content: space-around;
				align-items: center;
				margin: 6px 0;

				.switch {
					width: 30px;
				}

				.iconbox {
					width: 156px;
					height: 52px;
					background: #FFFFFF;
					border-radius: 4px;
					display: flex;
					justify-content: space-around;
					align-items: center;

					.iconimg {
						width: 32px;
						height: 32px;
					}

					.iconcatename {
						font-size: 14px;
						font-family: PingFangSC-Semibold, PingFang SC;
						font-weight: 600;
						color: #43496A;
						line-height: 16px;
					}
				}
			}
		}
	}

	.bottomlist {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		background: #F0F3F8;
		padding-bottom: 10px;
		width: 100%;
		flex: 1;

		overflow-y: scroll;

		.bottomlistinner {
			// background: red;
			display: flex;
			align-items: flex-start;
			flex-direction: column;
			justify-content: flex-start;
			margin-left: 15px;
			margin-top: 15px;

			.btitle {
				height: 24px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 600;
				color: #000000;
				line-height: 17px;
			}

			.bitem {
				text-align: left;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #000000;
				line-height: 17px;
				display: block;
			}

		}

	}
}

.container4 {
	width: 100%;
	height: calc(100vh - 188px);
	color: #333;
	display: flex;
	flex-direction: row;
}

.leftmap {
	// display: flex;
	width: 98%;
	margin: 0 1%;
	height: calc(100vh - 188px);
	margin-top: 10px;
	position:relative;

	.bmap-demo {
		flex: 1;
	}
}

.labelbox {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;

	border-radius: 5px;

	.labelcontent {
		border: solid 1px #fff;
		background:  #fff;
		border-radius: 4px;
		color: #333;
		font-size: 14px;
		padding: 4px;
		display: flex;
		flex-direction: row;
		padding: 5px 10px;
		justify-content: space-between;
		align-items: center;
		box-shadow:0 0 10px #06C;

		.iconimg {
			height: 30px;
			width: 30px;
		}

		.labeltext {
			margin-left: 10px;
		}

		// mar
	}

	.labeldown {
		margin-left:15px;
		width: 0;
		height: 0;
		border-top: 10px solid  #fff;
		border-right: 10px solid transparent;
		border-left: 10px solid transparent;

	}
}
</style>